import styled from "styled-components";
import { COLORS, HELPERS } from "../../shared";
import { MEDIA_QUERY } from "../../entities/Common";

export const FilterStyled = styled.div`
  margin-bottom: 30px;
  .filter {
    &-sorting {
      display: flex;
      align-items: center;
      &__item {
        width: 25px;
        height: 25px;
        cursor: pointer;
        transition: ${HELPERS.TRANSITION};
        margin-right: 10px;
        display: none;
        user-select: none;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          display: block;
        }
      }
      svg {
        fill: ${COLORS.PRIMARY_DARK};
        width: 100%;
        height: 100%;
      }
    }
    &-option {
      button {
        margin-right: 20px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    &-view {
      display: flex;
      align-items: center;
      & > div {
        width: 25px;
        height: 25px;
        cursor: pointer;
        transition: ${HELPERS.TRANSITION};
        opacity: 1;
        svg {
          width: 100%;
          height: 100%;
          fill: ${COLORS.PRIMARY_DARK};
          transition: ${HELPERS.TRANSITION};
        }
        &:nth-child(2) {
          width: 26px;
          margin-left: 10px;
          height: 26px;
        }
      }
    }
  }
  @media (max-width: ${MEDIA_QUERY.MOBILE}) {
    margin-bottom: 20px;
    .filter-sorting {
      &__item {
        width: 20px;
        height: 20px;
      }
    }
    .filter-view {
      > div {
        width: 20px;
        height: 20px;
        &:nth-child(2) {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
`;
